// src/store/index.js
import { createStore } from 'vuex'
import images from './images'

export default createStore({
    modules: { images },
    state: {
        user: null,
        permissions: {}
    },
    mutations: {
        SET_PERMISSIONS(state, perms) {
            state.permissions = perms
        },
        SET_USER(state, user) {
            state.user = user
            if (user) {
                localStorage.setItem('user', JSON.stringify(user))
            } else {
                localStorage.removeItem('user')
            }
        }
    },
    actions: {
        login({ commit }, userData) {
            commit('SET_USER', userData)
        },
        logout({ commit }) {
            commit('SET_USER', null)
            commit('SET_PERMISSIONS', {})
        },
        async initializeStore({ commit, dispatch }) {
            const storedUser = localStorage.getItem('user')
            if (storedUser) {
                try {
                    const user = JSON.parse(storedUser)
                    commit('SET_USER', user)
                    await dispatch('loadPermissions')
                } catch (e) {
                    console.warn('Неверный формат пользователя')
                    localStorage.removeItem('user')
                }
            }
        },
        async loadPermissions({ commit, state }) {
            if (!state.user?.id) return
            try {
                const { default: UserService } = await import('@/services/UserService')
                const res = await UserService.getMyGroups()
                const perms = {}
                res.data.data.forEach(g => {
                    Object.keys(g).forEach(k => {
                        if (k.endsWith('View') || k.endsWith('Edit') || k.endsWith('Manage')) {
                            if (g[k]) perms[k] = true
                        }
                    })
                })
                commit('SET_PERMISSIONS', perms)
            } catch (e) {
                console.error('Ошибка загрузки прав:', e)
                commit('SET_PERMISSIONS', {})
            }
        }
    },
    getters: {
        hasPermission: (state) => (perm) => !!state.permissions[perm],
        isAuthenticated: state => !!state.user,
        currentUser: state => state.user
    }
})